import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_OTP_VERIFY } from '@/configs/ecom/apis';

export const otpVerify = async (body: { mobile_number: string; otp: string }): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_OTP_VERIFY), {
      ...(body ?? {}),
      userAgent: 'WEB',
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
